import React from 'react';
import { FormFeedback } from '@piggybank/form';

export const FormFeedbackHook = () => <FormFeedback />;
